import '../scss/base.scss'
import './highlights.js'

document.querySelectorAll('.sqzly-recommended').forEach((el) => {
   // console.log('Squeezely recommended', el);
})

// Example event delegation:
document.querySelector('.sqzly-recommended').addEventListener('click', function(e) {
	if (e.target && e.target.matches('.dynamic-item')) {
		// console.log('Click op ', e.target);
  }
});

// Items worden na de addEventListener toegevoegd, maar de event listener werkt nog steeds:
// const newItem = document.createElement('div');
// newItem.className = 'dynamic-item';
// newItem.textContent = 'I am a new item';
// document.querySelector('.sqzly-recommended').appendChild(newItem);
